class LocalStorageManager {
  static isAvailable() {
    try {
      if (typeof window === 'undefined') {
        return false
      }
      return !!window.localStorage
    } catch (error) {
      return false
    }
  }

  static getItem(key, defaultValue = null) {
    try {
      if (!this.isAvailable()) {
        return defaultValue
      }

      const item = window.localStorage.getItem(key)

      if (item === null || item === undefined) {
        return defaultValue
      }

      if (item === 'undefined') {
        return defaultValue
      }

      return item
    } catch (error) {
      console.error(`Error al leer localStorage key "${key}":`, error)
      return defaultValue
    }
  }

  static setItem(key, value) {
    try {
      if (!this.isAvailable()) {
        return false
      }

      const valueToStore =
        typeof value === 'string' ? value : JSON.stringify(value)
      window.localStorage.setItem(key, valueToStore)
      return true
    } catch (error) {
      console.error(`Error al guardar localStorage key "${key}":`, error)
      return false
    }
  }

  static removeItem(key) {
    try {
      if (!this.isAvailable()) {
        return false
      }

      window.localStorage.removeItem(key)
      return true
    } catch (error) {
      console.error(`Error al eliminar localStorage key "${key}":`, error)
      return false
    }
  }

  static clear() {
    try {
      if (!this.isAvailable()) {
        return false
      }

      window.localStorage.clear()
      return true
    } catch (error) {
      console.error('Error al limpiar localStorage:', error)
      return false
    }
  }

  static getJSON(key, defaultValue = null) {
    try {
      const item = this.getItem(key, null)
      if (item === null) {
        return defaultValue
      }
      return JSON.parse(item)
    } catch (error) {
      console.error(`Error al parsear JSON localStorage key "${key}":`, error)
      this.removeItem(key)
      return defaultValue
    }
  }

  static setJSON(key, value) {
    return this.setItem(key, value)
  }

  static hasItem(key) {
    try {
      if (!this.isAvailable()) {
        return false
      }
      return window.localStorage.getItem(key) !== null
    } catch (error) {
      return false
    }
  }

  static keys() {
    try {
      if (!this.isAvailable()) {
        return []
      }
      return Object.keys(window.localStorage)
    } catch (error) {
      console.error('Error al obtener keys de localStorage:', error)
      return []
    }
  }

  static removeMultiple(keys) {
    let success = true
    keys.forEach(key => {
      if (!this.removeItem(key)) {
        success = false
      }
    })
    return success
  }
}

export default LocalStorageManager
